import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { OtpMaskDirective } from '@core/directives/appOtpMask.directive';
import { FocusToNextInputDirective } from '@core/directives/focus-to-next-input/focus-to-next-input.directive';
import { InputRestrictionDirective } from '@core/directives/input-restriction/input-restriction.directive';
@Component({
  standalone: true,
  imports: [
    // SharedModule,
    CommonModule,
    ReactiveFormsModule,
    FocusToNextInputDirective,
    InputRestrictionDirective,
    OtpMaskDirective
  ],
  selector: 'app-custom-otp',
  templateUrl: './custom-otp.component.html',
  styleUrls: ['./custom-otp.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CustomOtpComponent implements OnInit, OnChanges {
  @ViewChild('inputDiv', { static: true }) inputDiv!: ElementRef;

  @Input() otpBoxNormal: boolean = false;

  @Input() otpBox: number = 8; //set count of input box's

  @Input() isSubmitBtn: boolean = true; //show submit button
  @Input() submitBtnName: any = 'Submit'; //set submit button name
  @Input() submitBtnClass: any = 'btn btn-danger'; //Set classes
  @Output() sendOtp = new EventEmitter<any>(); //otp callback

  @Input() showCloseIcon: boolean = false; //show submit button
  @Output() closeTemplateModal = new EventEmitter<any>(); //closeTemplateModal

  @Input() isResendOTP: boolean = true; //show resend button
  @Input() isResendText: string = 'Resend?'; //show resend button
  @Output() resendOtp = new EventEmitter(); //resend callback
  @Input() resendOTPCounter: number = 30; //set resend timmer
  @Input() dynamicResendCounter: boolean = false; //show resend button

  @Input() title: null | string = null; //show mesg send to mobile
  @Input() message: null | string = null; //show mesg send to mobile
  @Input() showMesgOtpSendToMobile: null | string = null; //show mesg send to mobile
  @Input() resetOtp: boolean = false;
  @Input() onlyMessage: boolean = false;
  @Input() placeholder: string = 'OTP *';

  code!: FormArray;
  normalOtpInp!: FormControl

  count: any;
  constructor(
    private fb: FormBuilder,
    private cd: ChangeDetectorRef
  ) { }

  checkit() {
    let fullOtp: any = '';
    if (this.otpBoxNormal) {
      let inp: any = this.inputDiv.nativeElement.getElementsByClassName('isFirst').focus();

      fullOtp = inp.value;
    } else {
      this.code.value.map((val: any) => {
        fullOtp = fullOtp + val;
      });
    }
    this.sendOtp.emit(fullOtp);
  }
  ngOnInit(): void {
    if (this.otpBoxNormal) {
      this.normalOtpInp = new FormControl(null, [Validators.required, Validators.minLength(this.otpBox)]);
    } else {
      const controls: any[] = [];
      for (let i = 0; i < this.otpBox; i++) {
        controls.push(['', [Validators.required]]);
        // controls.push([i == this.otpBox-1?2:'', [Validators.required]]);
      }
      this.code = this.fb.array(controls);
    }

    this.resendOtpFn(false);
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes) {
      // if (this.inputDiv.nativeElement) {
      setTimeout(() => {

        // (this.inputDiv.getElementsByClassName('isFirst')[0] as HTMLInputElement).focus()
        // $($(this.inputDiv.nativeElement)[0]).find('input.isFirst')[0].focus();
      }, 1);
      // }
    }
    if (this.resetOtp) {
      this.code.reset('');
      this.resetOtp = false;
    }
  }

  getket(key: any) {
    return (<FormArray>this.code).controls[key] as FormControl;
  }
  numberOnly(event: any, lastItem?: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (lastItem) {
      this.lastFnCall();
    }
    return true;
  }
  lastFnCall() {
    setTimeout(() => {
      this.checkit();
    }, 1);
  }
  resendOtpFn(reset: boolean) {
    // Reset the appropriate form based on mode
    if (!this.otpBoxNormal) {
      // For FormArray, reset all controls
      this.code.controls.forEach(control => {
        control.reset('');
        control.markAsUntouched();
        control.markAsPristine();
      });
    } else {
      // For single FormControl
      this.normalOtpInp.reset('');
      this.normalOtpInp.markAsUntouched();
      this.normalOtpInp.markAsPristine();
    }

    // Force change detection
    this.cd.detectChanges();

    // Set focus after a small delay to ensure DOM is updated
    setTimeout(() => {
      const firstInput = this.inputDiv.nativeElement.getElementsByClassName('isFirst')[0] as HTMLInputElement;
      if (firstInput) {
        firstInput.focus();
        // Also clear the input value directly in case form reset didn't update the view
        firstInput.value = '';
      }
    }, 10);

    // Reset timer logic
    let count: number = this.resendOTPCounter;
    let inter = setInterval(() => {
      count -= 1;
      this.count = count;
      if (count == 0) {
        clearInterval(inter);
        this.count = null;
        if (this.dynamicResendCounter) {
          this.resendOTPCounter += 30;
        }
      }
      this.cd.markForCheck();
    }, 1000);

    if (reset) {
      this.resendOtp.emit();
    }
  }


  trackByFn(index: number, item: any): number {
    return index;
  }

  onOtpInputChange() {
    this.cd.markForCheck(); // Trigger change detection
  }

  handleCloseClick() {
    this.closeTemplateModal.emit(true);
    this.cd.detectChanges();
  }


}
